import { removeStylesFromEditorV3 } from "@azu-business/editor-v3";
import { AitCellData } from "aic";
import { STYLES_TO_CLEAN, STYLES_TO_DELETE } from "../../../config";

/**
 * Removes Optional and Notes styles from table cell text and comments.
 * Called from TlfContext before TableContext creates the replacedText runtime property.
 *
 * @template T - Content type for table cells (typically IEditorV3)
 * @template C - Cell type extending AitCellData
 * @param cell - The cell data to process
 * @returns Cell with styles removed from text and comments
 */
export const removeStylesFromCell = <T, C extends AitCellData<T>>(cell: C): C => {
  return {
    ...cell,
    text: removeStylesFromEditorV3(cell.text, STYLES_TO_DELETE, STYLES_TO_CLEAN),
    comments: removeStylesFromEditorV3(cell.comments, STYLES_TO_DELETE, STYLES_TO_CLEAN),
  };
};
